// Job chat attachments.
const chatFileCategories = [
	'bedc:cat:chat:channel-type:internal',
	'bedc:cat:chat:channel-type:external',
	'bedc:cat:chat:channel-type:announcement',
	'bedc:cat:chat:channel-type:review-form-item',
	'bedc:cat:chat:channel-type:bom-item-internal',
	'bedc:cat:chat:channel-type:woh-canvas-internal',
] as const;

// Job files section.
const jobFileCategories = [
	'bedc:cat:supplied',
	'bedc:cat:in-progress',
	'bedc:cat:completed',
	'bedc:cat:archived',
	'bedc:cat:chat',
] as const;

// FPC Job
const fpcJobFileCategories = ['bedc:category:original', 'bedc:category:variation'] as const;

export const categories = [...jobFileCategories, ...fpcJobFileCategories] as const;

export const fileTypes = [
	'bedc:architectural-plan',
	'bedc:engineering-plan',
	'bedc:ai-processed-plan',
	'bedc:wholehouseinput-plan',
	'bedc:intelliview-archive',
] as const;

export const mimeTypes = [
	// Input PDF plans
	'bedc:pdf',
	'bedc:not-pdf',
	'bedc:zip',
	// Ai Frame files
	'bedc:frame-file',
	'bedc:frame-flow',
	'bedc:floor-flow',
	'bedc:truss-flow',
	'bedc:frame-json',
	'bedc:pryda-xml',
	'bedc:revit',
	'bedc:ifc',
	'bedc:mitek-ifc',
	'bedc:alpine-json',
	'bedc:alpine-ifc',
	'bedc:ai-debug-file',
] as const;

const flags = [
	// file flags
	'bedc:flag:archived',
	'bedc:flag:current-version',
	...chatFileCategories,
] as const;

export const transactionId = 'transaction:id' as const;

export const icommandStatus = ['bedc:icommand:uploaded'] as const;
export const ids = [
	...categories,
	...fileTypes,
	...mimeTypes,
	...flags,
	transactionId,
	...icommandStatus,
] as const;
